import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '@/context/LanguageContext';
import { SITE } from '@/constants/testIds';

const LOGO_URL =
  'https://customer-assets.emergentagent.com/job_82895199-ac46-4908-9973-9983d7239f1a/artifacts/w46763t8_Centrale-%20Logo.png';

const Footer = () => {
  const { t } = useLanguage();
  return (
    <footer
      data-testid={SITE.footer}
      className="relative bg-[#0B0F0C] text-white pt-16 pb-10 border-t border-white/5"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3">
              <img src={LOGO_URL} alt="E-Central" className="h-11 w-11 rounded-full ring-1 ring-white/10" />
              <div>
                <div className="font-['Outfit'] text-xl font-semibold tracking-tight">
                  {t.common.brand}<span className="text-[#22C55E]">.</span>
                </div>
                <div className="text-[10px] uppercase tracking-[0.2em] text-white/50">
                  {t.common.brandSub}
                </div>
              </div>
            </div>
            <p className="mt-5 text-sm text-white/60 max-w-md leading-relaxed">
              {t.footer.tagline}
            </p>
          </div>

          <div className="md:col-span-3">
            <div className="text-xs font-bold uppercase tracking-[0.2em] text-[#22C55E] mb-4">
              {t.footer.quickLinks}
            </div>
            <ul className="space-y-2 text-sm">
              <li><a href="#hero" className="text-white/70 hover:text-white transition-colors">{t.nav.home}</a></li>
              <li><a href="#services" className="text-white/70 hover:text-white transition-colors">{t.nav.services}</a></li>
              <li><a href="#advantages" className="text-white/70 hover:text-white transition-colors">{t.nav.advantages}</a></li>
              <li><a href="#process" className="text-white/70 hover:text-white transition-colors">{t.nav.process}</a></li>
              <li><a href="#faq" className="text-white/70 hover:text-white transition-colors">{t.nav.faq}</a></li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="text-xs font-bold uppercase tracking-[0.2em] text-[#22C55E] mb-4">
              {t.footer.contact}
            </div>
            <a
              href="mailto:support@e-central.ca"
              className="text-sm text-white/80 hover:text-white transition-colors block"
            >
              support@e-central.ca
            </a>
            <a
              href="#contact"
              className="mt-5 inline-flex items-center justify-center bg-[#00A651] hover:bg-[#22C55E] text-white text-sm font-semibold py-2.5 px-5 rounded-xl transition-all duration-300 hover:-translate-y-0.5"
            >
              {t.nav.ctaHeader}
            </a>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 text-xs text-white/40">
          <div className="flex items-center gap-4 flex-wrap">
            <span>{t.footer.legal}</span>
            <Link
              to="/confidentialite"
              data-testid={SITE.privacyFooterLink}
              className="text-white/50 hover:text-white transition-colors"
            >
              {t.footer.privacy}
            </Link>
          </div>
          <div className="tracking-[0.18em] uppercase">E-Gestionnaire · MSSS · CIUSSS</div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
